import React from 'react';
import Card from "../../../components/ui/Card";
import DOMPurify from "dompurify";

export default function CriteriaDisplay({ criteria }) {
  return (
    <div className="flex-col space-y-2">
      {criteria.map(({ name, weightingRate, description }) =>
        name
          ? (
            <Card key={name} title={name}>
              {Number.isInteger(weightingRate) && (
                <p className="text-gray-900">
                  <span className="font-semibold">Pondération :</span>{" "}
                  {weightingRate}
                </p>
              )}
              {description && (
                <>
                  <p className="text-gray-900">
                    <span className="font-semibold">Description :</span>
                  </p>
                  <div
                    className="description-content text-gray-900"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(description),
                    }}
                  />
                </>
              )}
            </Card>
          )
          : (
            ""
          ),
      )}
    </div>
  );
}
